module.exports = __webpack_public_path__ + "img/pixartprinting-instagram-1.fc45038.png";